import { useState } from 'react';

import { Button } from 'components';
import { useIsConnectedAccountVip } from 'hooks/useIsConnectedAccountVip';
import { useIsUserPrime } from 'hooks/useIsUserPrime';
import { useTranslation } from 'libs/translations';
import { useAccountAddress, useAuthModal } from 'libs/wallet';
import { AccountModal } from './AccountModal';
import { UserButton } from './UserButton';

export const ConnectButton: React.FC = () => {
  const { accountAddress } = useAccountAddress();
  const { isConnectedAccountVip } = useIsConnectedAccountVip();
  const { openAuthModal } = useAuthModal();

  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleToggleModal = () => setIsModalOpen(current => !current);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleConnectButtonClick = () => {
    openAuthModal({
      analyticVariant: 'header_connect_button',
    });
  };

  const { isUserPrime: isAccountPrime, isLoading: isUserPrimeLoading } = useIsUserPrime({
    accountAddress,
  });

  if (isUserPrimeLoading) {
    return undefined;
  }

  if (accountAddress) {
    return (
      <div>
        <UserButton
          onClick={handleToggleModal}
          address={accountAddress}
          isPrime={isAccountPrime}
          isVip={isConnectedAccountVip}
        />

        {isModalOpen && (
          <AccountModal
            address={accountAddress}
            isPrime={isAccountPrime}
            isVip={isConnectedAccountVip}
            onClose={handleCloseModal}
          />
        )}
      </div>
    );
  }

  return <Button onClick={handleConnectButtonClick}>{t('connectButton.connect')}</Button>;
};
